import { http } from './config';

const CRM_PATH = 'crm';

export default {
  listar: object => {
    let params = `page=${object.page ? object.page : 1}`;
    if (object.id) {
      params += `&id=${object.id}`;
    }
    if (object.nome) {
      params += `&nome=${object.nome}`;
    }
    if (object.todosVendedores) {
      params += `&todosVendedores=true`;
    }
    return http.get(`${CRM_PATH}?${params}`);
  },
  resumo: object => {
    let params = `mes=${object.mes.toJSON()}`;
    if (object.id) {
      params += `&id=${object.id}`;
    }
    if (object.todosVendedores) {
      params += `&todosVendedores=true`;
    }
    return http.get(`${CRM_PATH}/resumo/grafico?${params}`);
  },
  listarUsuariosComDados: () => http.get(`${CRM_PATH}/resumo/usuarios`),
  atualizarDataLembrete: (crmId, data, mensagem) =>
    http.post(`${CRM_PATH}/${crmId}/data-lembrete`, {
      data,
      mensagem
    }),
  deletar: lead => http.delete(`${CRM_PATH}/${lead._id}`),
  converter: crmId => http.post(`${CRM_PATH}/${crmId}/converter`),
  getByCodigo: codigo => http.get(`${CRM_PATH}/${codigo}`),
  enviarMensagem: ({ id, mensagem }) =>
    http.post(`${CRM_PATH}/${id}/linha-do-tempo`, {
      mensagem
    })
};
